import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { LoggedUser } from 'src/app/services/authentication/authentication';
import { UserService } from 'src/app/services/user/user.service';
import { DropdownBankInput, DropdownInvestmentInput } from './money-dropdown-select';
import { ApiWithdrawalPortfolio } from 'src/app/services/rest-api/rest-api';

@Component({
  selector: 'libero-money-dropdown-select',
  templateUrl: './money-dropdown-select.component.html',
  styleUrls: ['./money-dropdown-select.component.scss'],
  standalone: false
})
export class MoneyDropdownSelectComponent implements OnInit {
  @Input() public availableInvestments?: DropdownInvestmentInput[];
  @Input() public availableWithdrawInvestments?: ApiWithdrawalPortfolio[];
  @Input() public set availableBankAccounts(value: DropdownBankInput[]) {
    this._availableBankAccounts = value;
    this.updateValue(this._availableBankAccounts[0]);
  }
  @Input() public formName!: AbstractControl;

  public _availableBankAccounts?: DropdownBankInput[];
  public selectedBankAccount: DropdownBankInput | null = null;
  public selectedInvestment: DropdownInvestmentInput | null = null;
  public selectedWithdrawInvestment: ApiWithdrawalPortfolio | null = null;

  public toggled = false;

  public get loggedUser(): LoggedUser {
    if(!this.userService.loggedUser || this.userService.loggedUser === null) {
      this.router.navigate(['/login']);
    }

    return this.userService.loggedUser!;
  }

  public constructor(
    private userService: UserService,
    private router: Router,
  ) { }

  public ngOnInit(): void {
    if (this._availableBankAccounts) {
      this.updateValue(this._availableBankAccounts[0]);
    }
    if (this.availableInvestments) {
      this.updateValue(this.availableInvestments[0]);
    }
    if (this.availableWithdrawInvestments) {
      this.updateValue(this.availableWithdrawInvestments[0]);
    }
  }

  public updateValue(newValue: DropdownBankInput | DropdownInvestmentInput | ApiWithdrawalPortfolio): void {
    let selectedId: string | number = NaN;
    if(
      'actualValue' in newValue &&
      (newValue['actualValue'] ||
      newValue['actualValue'] === 0)
    ) {
      selectedId = newValue.id;
      this.selectedInvestment = newValue as DropdownInvestmentInput;
    }
    if('accountNumber' in newValue && newValue['accountNumber']) {
      selectedId = newValue.id;
      this.selectedBankAccount = newValue as DropdownBankInput;
    }
    if('portfolioId' in newValue && newValue['portfolioId']) {
      selectedId = newValue.portfolioId;
      this.selectedWithdrawInvestment = newValue as ApiWithdrawalPortfolio;
    }

    if(this.formName) {
      this.formName.patchValue(selectedId);
      this.formName.markAsTouched();
      this.formName.markAsDirty();
    }

    this.toggled = false;
  }

  public toggle(): void {
    this.toggled = !this.toggled;
  }
}
